import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "officerTab",
  class: ""
}
const _hoisted_2 = { class: "actions text-end mb-2" }
const _hoisted_3 = { class: "col-12 border-rounded-gray" }
const _hoisted_4 = { class: "ucheader" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "Title" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "inputWrapper" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = { class: "inputWrapper" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "inputWrapper" }
const _hoisted_14 = { class: "inputWrapper" }
const _hoisted_15 = { class: "card mt-3" }
const _hoisted_16 = { class: "card-header" }
const _hoisted_17 = { class: "row d-flex align-items-center" }
const _hoisted_18 = { class: "col-6 text-end" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "card mt-3" }
const _hoisted_23 = { class: "card-header" }
const _hoisted_24 = { class: "row d-flex align-items-center" }
const _hoisted_25 = { class: "col-6 text-end" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "card-body" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "actions text-end mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectField = _resolveComponent("SelectField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-primary mt-2 me-2",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleAddOfficer()), ["prevent"]))
      }, "Add an Officer")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactFullReport!.officers, (officer, officerIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row px-3 py-2",
        key: _ctx.keyColumn
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, "Officer " + _toDisplayString(officerIndex + 1), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "btn btn-link confirm-remove",
                onClick: _withModifiers(($event: any) => (_ctx.handleRemoveOfficer(officerIndex)), ["prevent"])
              }, "Remove", 8, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">POST Number <span class=\"requiredfieldasterisk\">*</span></label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((officer.post_number) = $event),
              required: true
            }, null, 8, _hoisted_10), [
              [_vModelText, officer.post_number]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "validationSideBySideDiv" }, [
              _createElementVNode("div", { class: "left" }, [
                _createElementVNode("label", { style: {"font-weight":"bold"} }, "Name")
              ]),
              _createElementVNode("div", { class: "right" })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((officer.officer_name) = $event)
            }, null, 8, _hoisted_12), [
              [_vModelText, officer.officer_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Officer on Duty <span class=\"requiredfieldasterisk\">*</span></label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)),
            _createVNode(_component_SelectField, {
              modelValue: officer.officer_on_duty,
              "onUpdate:modelValue": ($event: any) => ((officer.officer_on_duty) = $event),
              "select-items": _ctx.contactsStore.getYesNoUnknown,
              "is-horizontal": false,
              "is-required": true,
              ref_for: true,
              ref: (el) => { _ctx.addValidatableComponent(el) }
            }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"validationSideBySideDiv\"><div class=\"left\"><label style=\"font-weight:bold;\">Injury Severity <span class=\"requiredfieldasterisk\">*</span></label></div><div class=\"right\"><span style=\"color:Red;visibility:hidden;\">Required</span></div></div>", 1)),
            _createVNode(_component_SelectField, {
              modelValue: officer.officer_injury,
              "onUpdate:modelValue": ($event: any) => ((officer.officer_injury) = $event),
              "select-items": _ctx.contactsStore.getInjurySeverity,
              "is-horizontal": false,
              "is-required": true,
              ref_for: true,
              ref: (el) => { _ctx.addValidatableComponent(el) }
            }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-6 text-start" }, [
                  _createElementVNode("h4", { class: "mb-0" }, "Weapons Used by Officer")
                ], -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _withModifiers(($event: any) => (_ctx.addWeaponsUsedByOfficer(officer)), ["prevent"])
                  }, "Add", 8, _hoisted_19)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-5" }, "Weapon Type"),
                _createElementVNode("div", { class: "col-5" }, "Weapon Discharged"),
                _createElementVNode("div", { class: "col-2" })
              ], -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(officer.weapon_details, (weaponDetail, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row border",
                  key: _ctx.keyColumn
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-5 p-2 text-center"])
                  }, [
                    _createVNode(_component_SelectField, {
                      modelValue: weaponDetail.weapon_type,
                      "onUpdate:modelValue": ($event: any) => ((weaponDetail.weapon_type) = $event),
                      "select-items": _ctx.contactsStore.getOfficerWeaponType,
                      "is-horizontal": false,
                      "is-required": true,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) }
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-5 p-2 text-center"])
                  }, [
                    _createVNode(_component_SelectField, {
                      modelValue: weaponDetail.weapon_discharged,
                      "onUpdate:modelValue": ($event: any) => ((weaponDetail.weapon_discharged) = $event),
                      "select-items": _ctx.contactsStore.getWeaponDischarged,
                      "is-horizontal": false,
                      "is-required": true,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) },
                      "is-nullable-bool": true
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(index) }, "col-2 p-2 mt-1 text-end"])
                  }, [
                    _createElementVNode("button", {
                      class: "btn-close me-3",
                      "aria-label": "Remove",
                      onClick: _withModifiers(($event: any) => (_ctx.handleRemoveOfficerField(officerIndex, `weapon_details`, officer.weapon_details, index)), ["prevent"])
                    }, null, 8, _hoisted_21)
                  ], 2)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-6 text-start" }, [
                  _createElementVNode("h4", { class: "mb-0" }, "Use of Force")
                ], -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _withModifiers(($event: any) => (_ctx.addUseOfForce(officer)), ["prevent"])
                  }, "Add", 8, _hoisted_26)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("div", { class: "col-5" }, "Type of Force Used"),
                _createElementVNode("div", { class: "col-5" }, "Subject(s) of Force"),
                _createElementVNode("div", { class: "col-2" })
              ], -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(officer.force_details, (forceDetailsData, forceDetailsIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row border",
                  key: _ctx.keyColumn
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(forceDetailsIndex) }, "col-5 p-2 text-center"])
                  }, [
                    _createVNode(_component_SelectField, {
                      modelValue: forceDetailsData.force_type,
                      "onUpdate:modelValue": ($event: any) => ((forceDetailsData.force_type) = $event),
                      "select-items": _ctx.contactsStore.getOfficerTypeOfForce,
                      "is-horizontal": false,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) }
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(forceDetailsIndex) }, "col-5 p-2 text-center"])
                  }, [
                    _createVNode(_component_SelectField, {
                      modelValue: forceDetailsData.directed_at,
                      "onUpdate:modelValue": ($event: any) => ((forceDetailsData.directed_at) = $event),
                      "select-items": _ctx.getDirectedAt,
                      mode: 'tags',
                      "is-required": true,
                      min: 1,
                      max: _ctx.getDirectedAt.length,
                      ref_for: true,
                      ref: (el) => { _ctx.addValidatableComponent(el) }
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items", "max"])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass([{ 'bg-light': _ctx.isAlternatingRow(forceDetailsIndex) }, "col-2 p-2 mt-1 text-end"])
                  }, [
                    _createElementVNode("button", {
                      class: "btn-close me-3",
                      "aria-label": "Remove",
                      onClick: _withModifiers(($event: any) => (_ctx.handleRemoveOfficerField(officerIndex, `force_details`, officer.force_details, forceDetailsIndex)), ["prevent"])
                    }, null, 8, _hoisted_28)
                  ], 2)
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    }), 128)),
    _withDirectives(_createElementVNode("div", _hoisted_29, [
      _createElementVNode("button", {
        class: "btn btn-primary mb-2 me-2",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleAddOfficer()), ["prevent"]))
      }, "Add an Officer")
    ], 512), [
      [_vShow, _ctx.contactsStore.contactFullReport!.officers && _ctx.contactsStore.contactFullReport!.officers.length > 0]
    ])
  ]))
}